import { usePreference } from './preferences.js';
import { tillDay } from './till-day.js';

export { tillDay };

/**
 * A reminder's "Not now": quiet for this person for the rest of today, back
 * tomorrow (2026-10-01).
 *
 * Both reminders that have one — styles still to finish, sizes below their
 * minimum — said "dismissed for the session … it comes back tomorrow", and
 * kept that in session storage. A tab stays open for days, and a reload or a
 * sign-out does not end a tab's session, so once dismissed the reminder never
 * came back (the client: "I refreshed and it didn't come back; sign in and out
 * didn't bring it back"). The day is the store's own calendar day.
 *
 * Kept with the person since decision 203, not the computer: one person's
 * "Not now" no longer quiets the reminder for everyone at that register.
 */

/** The reminders that have a "Not now". */
export type Reminder = 'finish-styles-banner' | 'reorder-banner';

/** Quiet when "Not now" was pressed today. */
export function quietToday(stored: string | null, today: string): boolean {
  return stored === today;
}

/** [quiet, notNow] for one reminder. */
export function useQuietUntilTomorrow(key: Reminder): readonly [boolean, () => void] {
  const [quieted, setQuieted] = usePreference('quiet-until', {});
  const today = tillDay(new Date());
  return [
    quietToday(quieted[key] ?? null, today),
    () => setQuieted({ ...quieted, [key]: today }),
  ] as const;
}
